/** Absolute percentages keep their color when filters change the other rows. */
export function magnitudeColor(percent: number | null): string {
	if (percent === null || !Number.isFinite(percent)) return "var(--fg-3)";
	if (percent >= 50) return "var(--chart-magnitude-high)";
	if (percent >= 25) return "var(--chart-magnitude-medium)";
	return "var(--chart-magnitude-low)";
}

/** Signed sentiment describes an opinion, not a share or a volume. */
export function sentimentColor(value: number | null): string {
	if (value === null || !Number.isFinite(value) || value === 0) return "var(--fg-3)";
	return value < 0 ? "var(--danger)" : "var(--success)";
}
